import { getStrapiBaseUrl, getWithLocaleFallback } from "../../services/strapiApi";

// Generic function to fetch data from Strapi API
export const fetchStrapiData = async (endpoint, locale) => {
  return getWithLocaleFallback(endpoint, { locale, fallbackLocale: 'fr', unwrap: false });
};

// Specific function to get global data (header/footer data)
export const getGlobalData = async (locale) => {
  const result = await getWithLocaleFallback("/global?populate=*", { locale, fallbackLocale: 'fr' });
  return result;
};

// Function to get media URL from Strapi
export const getStrapiMedia = (media) => {
  if (!media || !media.data || !media.data.attributes) {
    return null;
  }

  const { url } = media.data.attributes;
  return `${getStrapiBaseUrl()}${url}`;
};
